import { observer } from "mobx-react-lite";
import { useContext, useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";

import Loader from "../../../components/general/loader/Loader";
import LinkedInStrategyManagement from "../../../components/linkedin-manager/strategy/LinkedInStrategyManagement";
import { RoutesPaths } from "../../../constants/RoutePaths";
import useOnInitAsync from "../../../hooks/useOnInitAsync";
import useOnPoller from "../../../hooks/useOnPoller";
import usePageInitialization from "../../../hooks/usePageInitialization";
import linkedinService from "../../../services/linkedin/LinkedInService";
import { RootStoreContext } from "../../../stores/RootStoreContext";
import { SupervisionBreadcrumbs } from "../supervision/breadcrumbs/supervision.breadcrumbs";
import { LinkedInBreadcrumbs } from "./helpers/LinkedInManager.breadcrumbs";
import LinkedInChildApplication from "../../../components/linkedin-manager/LinkedInChildApplication";
import { LinkedInContextInitializers } from "./helpers/LinkedInContextInitializers";

interface Props { }

const LinkedInPage = (props: Props) => {
    const match = useParams<{ companyId: string }>();
    const history = useHistory();
    const { uiStore, companyStore, linkedinStore } = useContext(RootStoreContext);
    const plDataHash = useRef<string>("");

    useOnInitAsync(async () => {
        await LinkedInContextInitializers.InitializeLinkedInChildApplication(
            linkedinStore,
            history,
            companyStore.SelectedCompany?.companyId
        );
        uiStore.SetPageTitle(
            `LinkedIn Budgets for: ${companyStore.SelectedCompany?.companyName}`
        );
    });

    usePageInitialization({

        onCompanyContextCallBack: (company, uiStore) => {
            uiStore.SetPageTitle(
                `LinkedIn Budgets for: ${companyStore.SelectedCompany?.companyName}`
            );
            uiStore.AddBreadCrumbs(
                SupervisionBreadcrumbs.Companies(company.companyName),
                LinkedInBreadcrumbs.LinkedIn(company.companyId),
            );
        },

    });

    if (linkedinStore.IsDataLoading) {
        return <Loader position="normal" />;
    }

    return (
        <div>
            <LinkedInChildApplication linkedinChildApplication={linkedinStore?.linkedInChildApplication} />
            <LinkedInStrategyManagement companyId={match.companyId} />

        </div>
    );
};

export default observer(LinkedInPage);
